import { HStack, Text, Stack } from '@chakra-ui/react';
import { NestedHome } from '@habity/types';
import { getGeneralData } from '~/lib/homes/profile/general';

interface HomeGeneralDataProps {
  home: NestedHome;
}

export const HomeGeneralData = ({ home }: HomeGeneralDataProps) => {
  const generalData = getGeneralData(home);
  const hasFloorPlan = home?.images?.filter((i) => i.is_floor_plan).length > 0;

  return (
    <HStack
      flexWrap="wrap"
      columnGap={{ mobile: '8', desktop: '2' }}
      rowGap={{ mobile: '6', desktop: '8' }}
      pt={{
        mobile: hasFloorPlan ? '5' : '10',
        desktop: hasFloorPlan ? '5' : '20',
      }}
      pb={{ mobile: '10', desktop: '20' }}
      minW="145px"
    >
      {generalData.map((item, index) => (
        <Stack
          key={index}
          gap="1.5"
          minW={{ mobile: '45%', desktop: '160px' }} // Close to 50% on mobile to force 2-col layout (<50% to account for margins)
        >
          <Text
            size={{ mobile: 'sm', desktop: 'md' }}
            color="blackAlpha.800"
            fontWeight="light"
          >
            {item.label ?? 'Egenskaper'}
          </Text>
          <Text
            size={{ mobile: 'md', desktop: 'xl' }}
            color="black"
            fontWeight="medium"
          >
            {item.value}
          </Text>
        </Stack>
      ))}
    </HStack>
  );
};
